import { NgModule } from '@angular/core';
import { GetFormattedTimezonePipeModule } from 'src/app/angie-shared/pipes/get-formatted-timezone/get-formatted-timezone-pipe.module';
import { LocalizedDatePipeModule } from '../../../pipes/localized-date/localized-date-pipe.module';
import { SessionDetailsCardPipe } from './session-details-card-pipe.pipe';

const declarations = [SessionDetailsCardPipe];

const imports = [LocalizedDatePipeModule, GetFormattedTimezonePipeModule];

@NgModule({
	imports: imports,
	exports: [...declarations],
	declarations,
	providers: [SessionDetailsCardPipe]
})
export class SessionDetailsCardPipeModule {}
